import { useTranslation } from 'react-i18next';
import { errorCode } from '@posilka/client/api/client';

/** API xatosini foydalanuvchi tilida — `errors.<CODE>` kaliti bo'lsa undan. */
export function useErrorMessage() {
  const { t } = useTranslation();
  return (error: unknown) => {
    const code = errorCode(error);
    const key = code ? `errors.${code}` : null;
    return key && t(key) !== key ? t(key) : t('common.error');
  };
}
